<template>
  <div v-if="twitterUsername">
    <a class="twitter-timeline" :height="height" :href="`https://twitter.com/${twitterUsername}`">Tweets by {{ twitterUsername }}</a>
  </div>
</template>

<script>
import { computed, onMounted } from '@nuxtjs/composition-api';

export default {
  components: {},
  props: {
    user: {
      type: Object,
      required: true,
    },
    height: {
      type: String,
      default: '400',
      required: false,
    },
  },
  setup(props) {
    const twitterUsername = computed(() => props.user.twitterUsername);

    onMounted(() => {
      const script = document.createElement('script');
      script.async = true;
      script.src = 'https://platform.twitter.com/widgets.js';
      script.charset = 'utf-8';
      document.head.appendChild(script);
    });
    return { twitterUsername };
  },
};
</script>
